module.exports = __webpack_public_path__ + "img/incision_showcase-color-horizontal.5c295ef3.png";